import React from 'react'


const About = () => {
    return (
        <div>
            Under Development
        </div>
    )
}

export default About
